import { useState, useRef, useEffect, useCallback } from "react";

const API_BASE_URL = "";

/* ─── Icon ───────────────────────────────────────────────────────── */
const Icon = ({ d, size = 15, stroke = "currentColor", fill = "none", sw = 1.8 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const ICONS = {
  bold: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z",
  italic: "M19 4h-9M14 20H5M15 4 9 20",
  underline: "M6 3v7a6 6 0 0 0 12 0V3M4 21h16",
  strikethrough: "M16 4H9a3 3 0 0 0-2.83 4M4 12h16M8 20h7a3 3 0 0 0 2.83-4",
  code: "m8 9-3 3 3 3M16 9l3 3-3 3",
  codeblock: "M4 6h16M4 10h16M4 14h16M4 18h16",
  quote: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z",
  ul: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
  ol: "M10 6h11M10 12h11M10 18h11M4 6h1v4M4 10H3M6 18H3.6a.6.6 0 0 1-.6-.6v-.748a.6.6 0 0 1 .175-.424l2.65-2.652A1 1 0 0 0 6 13.489V13a1 1 0 0 0-1-1H3",
  link: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
  table: "M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18",
  attach: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
  mention: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  color: "M12 2a10 10 0 0 0 0 20M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z",
  indent: "M3 8h18M3 16h18M7 4l4 4-4 4",
  outdent: "M3 8h18M3 16h18M11 4l-4 4 4 4",
  send: "M22 2L11 13M22 2 15 22 11 13 2 9l20-7z",
  close: "M18 6 6 18M6 6l12 12",
  expand: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3",
  collapse: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3",
  trash: "M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
  undo: "M3 7v6h6M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13",
  redo: "M21 7v6h-6M3 17a9 9 0 0 0 9-9 9 9 0 0 0 6 2.3L21 13",
};

const TD_STYLE = "border:1px solid #cbd5e1;padding:6px 10px;min-width:60px;";

/* ─── EMOJIS ─────────────────────────────────────────────────────── */
const EMOJI_GROUPS = {
  "😀": ["😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃", "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "🤥", "😌", "😔", "😪", "😴", "😷", "🤒", "🤕", "🤢", "🤧", "🥵", "🥶", "😵", "🤯", "🤠", "🥳", "😎", "🤓", "🧐", "😕", "😟", "🙁", "😮", "😲", "😳", "🥺", "😦", "😧", "😨", "😰", "😥", "😢", "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫", "😤", "😡", "😠", "🤬", "😈", "👿", "💀", "💩", "🤡", "👹", "👺", "👻", "👽", "👾", "🤖"],
  "👋": ["👋", "🤚", "🖐", "✋", "🖖", "🤙", "👈", "👉", "👆", "🖕", "👇", "☝", "👍", "👎", "✊", "👊", "🤛", "🤜", "👏", "🙌", "👐", "🤲", "🤝", "🙏"],
  "❤️": ["❤", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❣", "💕", "💞", "💓", "💗", "💖", "💘", "💝"],
  "🎉": ["🎉", "🎊", "🎈", "🎁", "🎀", "🏆", "🥇", "🥈", "🥉", "🎵", "🎶", "🎷", "🎸", "🎹", "🎺", "🎻", "🥁"],
  "✅": ["✅", "❌", "⭕", "🛑", "⛔", "🚫", "💯", "❓", "❗", "♻", "🔔", "🔕", "📢", "📣"],
};

/* ─── TABLE HELPERS ──────────────────────────────────────────────── */
function getColIndex(cell) {
  return Array.from(cell.parentElement.querySelectorAll("td,th")).indexOf(cell);
}

function tableInsertRowAbove(table, cell) {
  const colCount = table.querySelector("tr").querySelectorAll("td,th").length;
  const newRow = document.createElement("tr");
  for (let i = 0; i < colCount; i++) {
    const td = document.createElement("td");
    td.style.cssText = TD_STYLE;
    td.innerHTML = "\u00A0";
    newRow.appendChild(td);
  }
  cell.parentElement.parentElement.insertBefore(newRow, cell.parentElement);
}

function tableInsertRowBelow(table, cell) {
  const colCount = table.querySelector("tr").querySelectorAll("td,th").length;
  const newRow = document.createElement("tr");
  for (let i = 0; i < colCount; i++) {
    const td = document.createElement("td");
    td.style.cssText = TD_STYLE;
    td.innerHTML = "\u00A0";
    newRow.appendChild(td);
  }
  const nextRow = cell.parentElement.nextElementSibling;
  const tbody = cell.parentElement.parentElement;
  if (nextRow) tbody.insertBefore(newRow, nextRow);
  else tbody.appendChild(newRow);
}

function tableDeleteRow(table, cell) {
  if (table.querySelectorAll("tr").length <= 1) return false;
  cell.parentElement.remove();
  return true;
}

function tableInsertColLeft(table, cell) {
  const idx = getColIndex(cell);
  table.querySelectorAll("tr").forEach(row => {
    const td = document.createElement("td");
    td.style.cssText = TD_STYLE;
    td.innerHTML = "\u00A0";
    const ref = row.querySelectorAll("td,th")[idx];
    if (ref) row.insertBefore(td, ref);
    else row.appendChild(td);
  });
}

function tableInsertColRight(table, cell) {
  const idx = getColIndex(cell);
  table.querySelectorAll("tr").forEach(row => {
    const td = document.createElement("td");
    td.style.cssText = TD_STYLE;
    td.innerHTML = "\u00A0";
    const ref = row.querySelectorAll("td,th")[idx];
    if (ref && ref.nextElementSibling) row.insertBefore(td, ref.nextElementSibling);
    else row.appendChild(td);
  });
}

function tableDeleteCol(table, cell) {
  const colCount = table.querySelector("tr")?.querySelectorAll("td,th").length || 0;
  if (colCount <= 1) return false;
  const idx = getColIndex(cell);
  table.querySelectorAll("tr").forEach(row => {
    const cells = row.querySelectorAll("td,th");
    if (cells[idx]) cells[idx].remove();
  });
  return true;
}

/* ─── TABLE TOOLBAR ──────────────────────────────────────────────── */
function TableToolbar({ cell, table, containerRef, onAction, onClose }) {
  const [pos, setPos] = useState(null);

  const updatePos = useCallback(() => {
    if (!cell || !containerRef?.current) return;
    const cRect = containerRef.current.getBoundingClientRect();
    const tRect = table.getBoundingClientRect();
    const scrollTop = containerRef.current.scrollTop || 0;

    let top = (tRect.top - cRect.top) - 40 + scrollTop;
    let left = tRect.left - cRect.left;

    if (top < 2) top = (tRect.bottom - cRect.top) + 4 + scrollTop;
    if (left < 0) left = 0;

    setPos({ top, left });
  }, [cell, table, containerRef]);

  useEffect(() => {
    updatePos();
    window.addEventListener("resize", updatePos);
    window.addEventListener("scroll", updatePos, true);
    return () => {
      window.removeEventListener("resize", updatePos);
      window.removeEventListener("scroll", updatePos, true);
    };
  }, [updatePos]);

  if (!pos) return null;

  const rowCount = table.querySelectorAll("tr").length;
  const colCount = table.querySelector("tr")?.querySelectorAll("td,th").length || 0;

  const Btn = ({ label, title, onClick, danger, disabled }) => (
    <button
      title={title}
      disabled={disabled}
      onMouseDown={e => { e.preventDefault(); if (!disabled) onClick(); }}
      style={{
        display: "inline-flex", alignItems: "center", gap: 3,
        padding: "0 8px", height: 26, border: "none", borderRadius: 4,
        background: "transparent",
        color: disabled ? "#cbd5e1" : danger ? "#ef4444" : "#374151",
        fontSize: 11.5, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: "inherit", whiteSpace: "nowrap", flexShrink: 0,
        transition: "background .1s",
      }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = danger ? "#fff1f2" : "#f1f5f9"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
    >
      {label}
    </button>
  );

  const TSep = () => <div style={{ width: 1, height: 16, background: "#e2e8f0", flexShrink: 0 }} />;
  const TLabel = ({ children }) => (
    <span style={{ fontSize: 9.5, fontWeight: 800, color: "#94a3b8", padding: "0 5px 0 4px", letterSpacing: ".07em", textTransform: "uppercase", flexShrink: 0 }}>
      {children}
    </span>
  );

  return (
    <div
      style={{
        position: "absolute",
        top: pos.top,
        left: pos.left,
        zIndex: 500,
        display: "flex",
        alignItems: "center",
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 8,
        boxShadow: "0 4px 20px rgba(0,0,0,.13), 0 1px 4px rgba(0,0,0,.07)",
        padding: "3px 4px",
        userSelect: "none",
        flexWrap: "nowrap",
        overflowX: "auto",
        maxWidth: "calc(100% - 8px)",
      }}
    >
      <TLabel>Row</TLabel>
      <Btn label="↑ Above" title="Insert row above" onClick={() => onAction("rowAbove")} />
      <Btn label="↓ Below" title="Insert row below" onClick={() => onAction("rowBelow")} />
      <Btn label="✕ Row" title="Delete row" onClick={() => onAction("rowDelete")} danger disabled={rowCount <= 1} />
      <TSep />
      <TLabel>Col</TLabel>
      <Btn label="← Left" title="Insert column left" onClick={() => onAction("colLeft")} />
      <Btn label="Right →" title="Insert column right" onClick={() => onAction("colRight")} />
      <Btn label="✕ Col" title="Delete column" onClick={() => onAction("colDelete")} danger disabled={colCount <= 1} />
      <TSep />
      <Btn
        label={<span style={{ display: "flex", alignItems: "center", gap: 4 }}><Icon d={ICONS.trash} size={11} />Table</span>}
        title="Delete entire table"
        onClick={() => onAction("tableDelete")}
        danger
      />
      <TSep />
      <button
        onMouseDown={e => { e.preventDefault(); onClose(); }}
        title="Close"
        style={{ display: "flex", alignItems: "center", padding: "3px 5px", border: "none", background: "transparent", cursor: "pointer", color: "#94a3b8", borderRadius: 4, flexShrink: 0 }}
        onMouseEnter={e => e.currentTarget.style.background = "#f1f5f9"}
        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
      >
        <Icon d={ICONS.close} size={12} />
      </button>
    </div>
  );
}

/* ─── COLUMN RESIZE ──────────────────────────────────────────────── */
function useColResize() {
  const state = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      if (!state.current) return;
      const newW = Math.max(40, state.current.startW + (e.clientX - state.current.startX));
      state.current.cell.style.width = newW + "px";
      state.current.cell.style.minWidth = newW + "px";
    };
    const onUp = () => {
      if (!state.current) return;
      state.current = null;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
  }, []);

  return useCallback((e, cell) => {
    e.preventDefault();
    e.stopPropagation();
    state.current = { startX: e.clientX, startW: cell.offsetWidth, cell };
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  }, []);
}

/* ─── TABLE RESIZE HANDLE ────────────────────────────────────────── */
function TableResizeHandle({ table, containerRef }) {
  const [pos, setPos] = useState(null);
  const [dragging, setDragging] = useState(false);
  const dragState = useRef(null);

  const updatePos = useCallback(() => {
    if (!table || !containerRef?.current) return;
    const cRect = containerRef.current.getBoundingClientRect();
    const tRect = table.getBoundingClientRect();
    const scrollTop = containerRef.current.scrollTop || 0;
    setPos({
      top: tRect.bottom - cRect.top + scrollTop - 6,
      left: tRect.right - cRect.left - 6,
    });
  }, [table, containerRef]);

  useEffect(() => {
    updatePos();
    window.addEventListener("resize", updatePos);
    window.addEventListener("scroll", updatePos, true);
    return () => {
      window.removeEventListener("resize", updatePos);
      window.removeEventListener("scroll", updatePos, true);
    };
  }, [updatePos]);

  useEffect(() => {
    if (!table) return;
    const ro = new ResizeObserver(updatePos);
    ro.observe(table);
    return () => ro.disconnect();
  }, [table, updatePos]);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    const parentW = table.parentElement?.offsetWidth || table.offsetWidth;
    dragState.current = {
      startX: e.clientX,
      startY: e.clientY,
      startW: table.offsetWidth,
      startH: table.offsetHeight,
      parentW,
    };
    setDragging(true);
    document.body.style.cursor = "nwse-resize";
    document.body.style.userSelect = "none";

    const onMove = (me) => {
      const { startX, startY, startW, startH, parentW: pw } = dragState.current;
      const dX = me.clientX - startX;
      const dY = me.clientY - startY;
      const newW = Math.min(pw, Math.max(80, startW + dX));
      table.style.width = ((newW / pw) * 100).toFixed(1) + "%";
      table.style.minWidth = "";
      if (startH + dY > 40) {
        table.style.minHeight = Math.max(40, startH + dY) + "px";
      }
      updatePos();
    };

    const onUp = () => {
      dragState.current = null;
      setDragging(false);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  }, [table, updatePos]);

  if (!pos) return null;

  return (
    <>
      <TableFocusOutline table={table} containerRef={containerRef} />
      <div
        title="Drag to resize table"
        onMouseDown={handleMouseDown}
        style={{
          position: "absolute",
          top: pos.top,
          left: pos.left,
          width: 14,
          height: 14,
          borderRadius: 3,
          background: dragging ? "#5b21b6" : "#7c3aed",
          border: "2px solid #fff",
          boxShadow: dragging
            ? "0 0 0 2px rgba(124,58,237,.45), 0 2px 6px rgba(0,0,0,.25)"
            : "0 1px 4px rgba(0,0,0,.22)",
          cursor: "nwse-resize",
          zIndex: 501,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "background .1s, box-shadow .1s",
        }}
        onMouseEnter={e => { if (!dragging) e.currentTarget.style.background = "#6d28d9"; }}
        onMouseLeave={e => { if (!dragging) e.currentTarget.style.background = "#7c3aed"; }}
      >
        <svg width="8" height="8" viewBox="0 0 8 8" style={{ display: "block" }}>
          <circle cx="2" cy="2" r="1" fill="rgba(255,255,255,.7)" />
          <circle cx="6" cy="2" r="1" fill="rgba(255,255,255,.7)" />
          <circle cx="2" cy="6" r="1" fill="rgba(255,255,255,.7)" />
          <circle cx="6" cy="6" r="1" fill="rgba(255,255,255,.7)" />
        </svg>
      </div>
      {dragging && <TableSizeTooltip table={table} pos={pos} />}
    </>
  );
}

function TableFocusOutline({ table, containerRef }) {
  const [rect, setRect] = useState(null);

  const update = useCallback(() => {
    if (!table || !containerRef?.current) return;
    const cRect = containerRef.current.getBoundingClientRect();
    const tRect = table.getBoundingClientRect();
    const scrollTop = containerRef.current.scrollTop || 0;
    setRect({
      top: tRect.top - cRect.top + scrollTop - 3,
      left: tRect.left - cRect.left - 3,
      width: tRect.width + 6,
      height: tRect.height + 6,
    });
  }, [table, containerRef]);

  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [update]);

  useEffect(() => {
    if (!table) return;
    const ro = new ResizeObserver(update);
    ro.observe(table);
    return () => ro.disconnect();
  }, [table, update]);

  if (!rect) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        border: "1.5px dashed rgba(124,58,237,.45)",
        borderRadius: 4,
        pointerEvents: "none",
        zIndex: 498,
        boxSizing: "border-box",
      }}
    />
  );
}

function TableSizeTooltip({ table, pos }) {
  const [label, setLabel] = useState("");

  useEffect(() => {
    const tick = () => {
      setLabel(`${table.offsetWidth}w × ${table.offsetHeight}h`);
      rafId = requestAnimationFrame(tick);
    };
    let rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [table]);

  return (
    <div
      style={{
        position: "absolute",
        top: pos.top - 28,
        left: pos.left - 40,
        background: "#1e293b",
        color: "#fff",
        fontSize: 11,
        fontWeight: 600,
        padding: "3px 8px",
        borderRadius: 5,
        whiteSpace: "nowrap",
        pointerEvents: "none",
        zIndex: 600,
        letterSpacing: ".02em",
      }}
    >
      {label}
    </div>
  );
}

/* ─── TABLE PICKER ───────────────────────────────────────────────── */
function TablePicker({ onInsert, onClose }) {
  const [hover, setHover] = useState({ r: 0, c: 0 });
  return (
    /* ✅ FIX: stop mousedown propagation so outside-click handler doesn't close it */
    <div
      style={styles.floatingPanel}
      onMouseDown={e => e.stopPropagation()}
    >
      <div style={{ fontSize: 11, color: "#64748b", marginBottom: 8, fontWeight: 600 }}>
        {hover.r > 0 ? `${hover.r} × ${hover.c} table` : "Insert table"}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 22px)", gap: 3 }}>
        {Array.from({ length: 36 }, (_, i) => {
          const r = Math.floor(i / 6) + 1, c = (i % 6) + 1;
          const active = r <= hover.r && c <= hover.c;
          return (
            <div
              key={i}
              onMouseEnter={() => setHover({ r, c })}
              onMouseLeave={() => setHover({ r: 0, c: 0 })}
              /* ✅ FIX: use onMouseDown + preventDefault instead of onClick */
              onMouseDown={e => { e.preventDefault(); e.stopPropagation(); onInsert(r, c); onClose(); }}
              style={{
                width: 22, height: 22, borderRadius: 3,
                border: `1px solid ${active ? "#7c3aed" : "#e2e8f0"}`,
                background: active ? "#ede9fe" : "#f8fafc",
                cursor: "pointer",
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

/* ─── EMOJI PICKER ───────────────────────────────────────────────── */
function EmojiPickerPanel({ onPick, onClose, savedRange, editorRef }) {
  const [activeGroup, setActiveGroup] = useState(Object.keys(EMOJI_GROUPS)[0]);
  const ref = useRef();

  useEffect(() => {
    /* ✅ FIX: close only when clicking truly outside the panel */
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    /* use capture=true so this fires before other handlers */
    document.addEventListener("mousedown", h, true);
    return () => document.removeEventListener("mousedown", h, true);
  }, [onClose]);

  return (
    <div
      ref={ref}
      /* ✅ FIX: stop propagation on the panel container */
      onMouseDown={e => e.stopPropagation()}
      style={{ ...styles.floatingPanel, width: 280, padding: 0, overflow: "hidden" }}
    >
      <div style={{ display: "flex", borderBottom: "1px solid #f1f5f9", padding: "6px 8px", gap: 2 }}>
        {Object.keys(EMOJI_GROUPS).map(g => (
          <button
            key={g}
            /* ✅ FIX: onMouseDown + preventDefault keeps selection alive */
            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); setActiveGroup(g); }}
            style={{
              border: "none",
              background: activeGroup === g ? "#ede9fe" : "transparent",
              borderRadius: 6, padding: "4px 8px", cursor: "pointer", fontSize: 14,
            }}
          >
            {g}
          </button>
        ))}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", padding: "8px", maxHeight: 160, overflowY: "auto", gap: 2 }}>
        {EMOJI_GROUPS[activeGroup].map(em => (
          <button
            key={em}
            /* ✅ FIX: onMouseDown + preventDefault so the editor doesn't lose focus/selection */
            onMouseDown={e => {
              e.preventDefault();
              e.stopPropagation();
              onPick(em);
              onClose();
            }}
            style={{
              border: "none", background: "transparent", borderRadius: 6,
              padding: 4, fontSize: 18, cursor: "pointer", lineHeight: 1,
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#f1f5f9"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            {em}
          </button>
        ))}
      </div>
    </div>
  );
}

/* ─── COLOR PALETTE ──────────────────────────────────────────────── */
const TEXT_COLORS = ["#ef4444", "#f97316", "#f59e0b", "#22c55e", "#14b8a6", "#3b82f6", "#8b5cf6", "#ec4899", "#000000", "#64748b", "#ffffff"];
const HIGHLIGHT_COLORS = ["#fef08a", "#bbf7d0", "#bfdbfe", "#e9d5ff", "#fecaca", "#fed7aa", "#ccfbf1", "#f0fdf4"];

function ColorPalette({ cmd, onClose }) {
  const ref = useRef();

  useEffect(() => {
    /* ✅ FIX: use capture phase so this fires reliably before other mousedown handlers */
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", h, true);
    return () => document.removeEventListener("mousedown", h, true);
  }, [onClose]);

  const colors = cmd === "foreColor" ? TEXT_COLORS : HIGHLIGHT_COLORS;

  return (
    <div
      ref={ref}
      /* ✅ FIX: stop propagation so the outside-click handler ignores clicks inside */
      onMouseDown={e => e.stopPropagation()}
      style={{ ...styles.floatingPanel, width: 180, padding: 10 }}
    >
      <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 8 }}>
        {cmd === "foreColor" ? "Text color" : "Highlight"}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
        {colors.map(c => (
          <div
            key={c}
            /* ✅ FIX: onMouseDown + preventDefault keeps the editor selection intact
               so execCommand applies to the correct range */
            onMouseDown={e => {
              e.preventDefault();
              e.stopPropagation();
              document.execCommand(cmd, false, c);
              onClose();
            }}
            style={{
              width: 22, height: 22, borderRadius: 4,
              background: c, cursor: "pointer",
              border: "1.5px solid rgba(0,0,0,.12)",
            }}
          />
        ))}
      </div>
    </div>
  );
}

/* ─── LINK EDITOR ────────────────────────────────────────────────── */
function LinkEditor({ initial = {}, onSave, onClose }) {
  const [text, setText] = useState(initial.text || "");
  const [url, setUrl] = useState(initial.url || "");
  return (
    <div style={styles.linkEditor}>
      <div style={styles.linkEditorHeader}>
        <span style={{ fontWeight: 600, fontSize: 13 }}>Insert link</span>
        <button style={styles.iconBtn} onClick={onClose}><Icon d={ICONS.close} size={14} /></button>
      </div>
      <div style={{ padding: "12px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
        <input placeholder="Display text" value={text} onChange={e => setText(e.target.value)} style={styles.miniInput} />
        <input
          placeholder="https://example.com"
          value={url}
          onChange={e => setUrl(e.target.value)}
          style={styles.miniInput}
          onKeyDown={e => e.key === "Enter" && onSave(text, url)}
        />
      </div>
      <div style={{ padding: "8px 14px 12px", display: "flex", gap: 8 }}>
        <button style={styles.primaryBtn} onClick={() => onSave(text, url)} disabled={!url}>Insert</button>
        <button style={styles.ghostBtn} onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}

/* ─── MENTION DROPDOWN ───────────────────────────────────────────── */
function MentionDropdown({ users, query, onSelect, pos, activeIndex }) {
  const filtered = users.filter(u =>
    `${u.firstName} ${u.lastName}`.toLowerCase().includes(query.toLowerCase())
  ).slice(0, 8);

  const listRef = useRef(null);

  useEffect(() => {
    if (!listRef.current) return;
    const activeEl = listRef.current.querySelector(`[data-idx="${activeIndex}"]`);
    if (activeEl) activeEl.scrollIntoView({ block: "nearest" });
  }, [activeIndex]);

  if (!filtered.length) return null;

  return (
    <div
      ref={listRef}
      style={{
        ...styles.floatingPanel,
        position: "fixed",
        top: pos.y,
        left: pos.x,
        width: 240,
        padding: "4px 0",
        zIndex: 9999,
        maxHeight: 280,
        overflowY: "auto",
      }}
    >
      {filtered.map((u, idx) => {
        const isActive = idx === activeIndex;
        const initials = `${u.firstName?.[0] || ""}${u.lastName?.[0] || ""}`.toUpperCase();
        const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;

        return (
          <div
            key={u.id}
            data-idx={idx}
            onMouseDown={e => { e.preventDefault(); onSelect(u); }}
            style={{
              display: "flex", alignItems: "center", gap: 10, padding: "8px 12px",
              cursor: "pointer", background: isActive ? "#ede9fe" : "transparent",
              transition: "background .1s",
            }}
            onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "#f8fafc"; }}
            onMouseLeave={e => { e.currentTarget.style.background = isActive ? "#ede9fe" : "transparent"; }}
          >
            <div style={{
              width: 32, height: 32, borderRadius: "50%", overflow: "hidden", flexShrink: 0,
              background: "#ede9fe", display: "flex", alignItems: "center", justifyContent: "center",
              border: "2px solid #fff", boxShadow: "0 1px 4px rgba(0,0,0,.12)",
            }}>
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt={`${u.firstName} ${u.lastName}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={e => {
                    e.currentTarget.style.display = "none";
                    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <span style={{
                display: photoUrl ? "none" : "flex", alignItems: "center", justifyContent: "center",
                width: "100%", height: "100%", fontSize: 11, fontWeight: 700, color: "#7c3aed",
              }}>{initials}</span>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {u.firstName} {u.lastName}
              </div>
              {u.team?.name && (
                <div style={{ fontSize: 11, color: "#94a3b8", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {u.team.name}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ─── ATTACH CHIP ────────────────────────────────────────────────── */
function AttachChip({ name, size, onRemove }) {
  const ext = name.split(".").pop()?.toUpperCase() || "FILE";
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 8px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#f8fafc", fontSize: 12, color: "#1e293b", maxWidth: 160 }}>
      <span style={{ fontWeight: 700, fontSize: 10, color: "#463aed", background: "#ede9fe", padding: "1px 4px", borderRadius: 3 }}>{ext}</span>
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>{name}</span>
      {size && <span style={{ color: "#94a3b8", fontSize: 10 }}>{(size / 1024).toFixed(0)}kb</span>}
      <button onClick={onRemove} style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0, color: "#94a3b8", display: "flex" }}>
        <Icon d={ICONS.close} size={12} />
      </button>
    </div>
  );
}

const TBSep = () => <div style={{ width: 1, height: 18, background: "#e2e8f0", margin: "0 2px", flexShrink: 0 }} />;

/* ═══════════════════════════════════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════════════════════════════════ */
export default function NewCommentEditor({
  initialHtml = "",
  placeholder = "Add a comment… (Ctrl + Enter to submit)",
  mentionableUsers = [],
  onSubmit, onCancel, onDraft,
  autoFocus = false,
  showCancelBtn = true,
  submitLabel = "Save",
  compact = false,
}) {
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const editorWrapRef = useRef(null);
  const fileRef = useRef(null);
  const savedRange = useRef(null);

  const [panel, setPanel] = useState(null);
  const [panelPos, setPanelPos] = useState({ x: 0, y: 0 });
  const [linkTarget, setLinkTarget] = useState(null);
  const [linkInit, setLinkInit] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionActive, setMentionActive] = useState(false);
  const [mentionPos, setMentionPos] = useState({ x: 0, y: 0 });
  const [activeMentionIndex, setActiveMentionIndex] = useState(0);
  const mentionRangeRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [hasContent, setHasContent] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [previewMode, setPreviewMode] = useState(false);

  const [tableCtx, setTableCtx] = useState(null);
  const startResize = useColResize();

  const filteredMentionUsers = mentionableUsers
    .filter(u => `${u.firstName} ${u.lastName}`.toLowerCase().includes(mentionQuery.toLowerCase()))
    .slice(0, 8);

  // ── init ──
  useEffect(() => {
    if (editorRef.current && initialHtml) {
      editorRef.current.innerHTML = initialHtml;
      syncContent();
    }
  }, []);

  useEffect(() => {
    if (autoFocus) editorRef.current?.focus();
  }, [autoFocus]);

  const syncContent = useCallback(() => {
    const el = editorRef.current;
    if (!el) return;
    const text = el.innerText?.trim() || "";
    setHasContent(text.length > 0);
    setCharCount(text.length);
    onDraft?.(el.innerHTML);
  }, [onDraft]);

  const saveRange = () => {
    const sel = window.getSelection();
    if (sel?.rangeCount) savedRange.current = sel.getRangeAt(0).cloneRange();
  };

  const restoreRange = () => {
    const sel = window.getSelection();
    if (savedRange.current && sel) {
      sel.removeAllRanges();
      sel.addRange(savedRange.current.cloneRange());
    }
  };

  const exec = (cmd, value = null) => {
    editorRef.current?.focus();
    restoreRange();
    document.execCommand(cmd, false, value);
    saveRange();
    syncContent();
  };

  // ── detect table cell from selection ──
  const detectTableCtx = useCallback(() => {
    const sel = window.getSelection();
    if (!sel?.rangeCount) { setTableCtx(null); return; }
    let node = sel.getRangeAt(0).startContainer;
    if (node.nodeType === Node.TEXT_NODE) node = node.parentElement;
    const cell = node?.closest?.("td,th");
    const table = cell?.closest?.("table");
    const editor = editorRef.current;
    if (cell && table && editor?.contains(table)) {
      setTableCtx(prev => {
        if (prev?.cell === cell && prev?.table === table) return prev;
        return { cell, table };
      });
    } else {
      setTableCtx(null);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("selectionchange", detectTableCtx);
    return () => document.removeEventListener("selectionchange", detectTableCtx);
  }, [detectTableCtx]);

  // ── inject col resize handles via MutationObserver ──
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;
    const inject = () => {
      editor.querySelectorAll("td,th").forEach(cell => {
        if (cell.querySelector(".col-rh")) return;
        cell.style.position = "relative";
        const h = document.createElement("div");
        h.className = "col-rh";
        h.contentEditable = "false";
        h.addEventListener("mousedown", (e) => startResize(e, cell));
        cell.appendChild(h);
      });
    };
    const obs = new MutationObserver(inject);
    obs.observe(editor, { childList: true, subtree: true });
    inject();
    return () => obs.disconnect();
  }, [startResize]);

  // ── table actions ──
  const handleTableAction = useCallback((action) => {
    if (!tableCtx) return;
    const { cell, table } = tableCtx;
    if (action === "tableDelete") {
      table.remove();
      setTableCtx(null);
      syncContent();
      return;
    }
    switch (action) {
      case "rowAbove": tableInsertRowAbove(table, cell); break;
      case "rowBelow": tableInsertRowBelow(table, cell); break;
      case "rowDelete": tableDeleteRow(table, cell); break;
      case "colLeft": tableInsertColLeft(table, cell); break;
      case "colRight": tableInsertColRight(table, cell); break;
      case "colDelete": tableDeleteCol(table, cell); break;
    }
    syncContent();
    requestAnimationFrame(detectTableCtx);
  }, [tableCtx, detectTableCtx, syncContent]);

  // ── toolbar panel toggle ──
  // ✅ FIX: save the caret range BEFORE opening a panel, so execCommand
  //         (color/emoji) applies to the correct selection later.
  const togglePanel = (name, e) => {
    saveRange();
    if (panel === name) { setPanel(null); return; }
    const rect = e.currentTarget.getBoundingClientRect();
    setPanelPos({ x: rect.left, y: rect.bottom + 6 });
    setPanel(name);
  };

  // ── insert table ──
  const insertTable = (rows, cols) => {
    restoreRange();
    editorRef.current?.focus();
    let html = `<table style="border-collapse:collapse;width:100%;margin:8px 0;"><tbody>`;
    for (let r = 0; r < rows; r++) {
      html += "<tr>" + Array.from({ length: cols }).map(() =>
        `<td style="${TD_STYLE}">\u00A0</td>`).join("") + "</tr>";
    }
    html += "</tbody></table><p><br></p>";
    document.execCommand("insertHTML", false, html);
    syncContent();
  };

  // ── link ──
  const handleLinkSave = (text, url) => {
    setPanel(null);
    if (!url) return;
    restoreRange();
    editorRef.current?.focus();
    if (linkTarget) {
      linkTarget.href = url;
      linkTarget.textContent = text || url;
    } else {
      document.execCommand("insertHTML", false,
        `<a href="${url}" target="_blank" rel="noopener noreferrer" data-link="true">${text || url}</a>\u00A0`);
    }
    setLinkTarget(null);
    syncContent();
  };

  // ── emoji ──
  // ✅ FIX: restore the saved range before inserting so the emoji lands
  //         at the caret position, not at the document end.
  const insertEmoji = (emoji) => {
    restoreRange();
    editorRef.current?.focus();
    document.execCommand("insertText", false, emoji);
    syncContent();
  };

  // ── mention ──
  const getCaretCoords = (range) => {
    const r = range || window.getSelection()?.getRangeAt(0);
    if (!r) return { x: 0, y: 0 };
    const rect = r.getBoundingClientRect();
    return { x: rect.left, y: rect.bottom + 6 };
  };

  const updateMentionPos = useCallback(() => {
    if (!mentionRangeRef.current) return;
    try {
      const rect = mentionRangeRef.current.getBoundingClientRect();
      setMentionPos({ x: rect.left, y: rect.bottom + 6 });
    } catch (_) { }
  }, []);

  useEffect(() => {
    if (!mentionActive) return;
    window.addEventListener("scroll", updateMentionPos, true);
    window.addEventListener("resize", updateMentionPos);
    return () => {
      window.removeEventListener("scroll", updateMentionPos, true);
      window.removeEventListener("resize", updateMentionPos);
    };
  }, [mentionActive, updateMentionPos]);

  const handleInput = () => {
    syncContent();
    const el = editorRef.current;
    if (!el) return;
    const sel = window.getSelection();
    if (!sel?.rangeCount) { setMentionActive(false); return; }
    const range = sel.getRangeAt(0).cloneRange();
    range.selectNodeContents(el);
    range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
    const text = range.toString();
    const atIdx = text.lastIndexOf("@");
    if (atIdx !== -1) {
      const after = text.slice(atIdx + 1);
      if (!after.includes(" ") && !after.includes("\n")) {
        setMentionQuery(after);
        setMentionActive(true);
        const currentRange = sel.getRangeAt(0).cloneRange();
        mentionRangeRef.current = currentRange;
        setMentionPos(getCaretCoords(currentRange));
        setActiveMentionIndex(0);
        return;
      }
    }
    setMentionActive(false);
    mentionRangeRef.current = null;
  };

  const insertMention = (user) => {
    const el = editorRef.current;
    if (!el) return;
    const sel = window.getSelection();
    if (!sel?.rangeCount) return;
    const range = sel.getRangeAt(0).cloneRange();
    range.selectNodeContents(el);
    range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
    const fullText = range.toString();
    const atIdx = fullText.lastIndexOf("@");
    for (let i = 0; i < fullText.length - atIdx; i++) document.execCommand("delete");
    const chip = document.createElement("span");
    chip.contentEditable = "false";
    chip.style.cssText = "background:#ede9fe;color:#7c3aed;border-radius:4px;padding:1px 6px;font-size:13px;font-weight:600;";
    chip.dataset.userId = user.id;
    chip.textContent = `@${user.firstName} ${user.lastName}`;
    const space = document.createTextNode("\u00A0");
    const cur = sel.getRangeAt(0);
    cur.insertNode(space); cur.insertNode(chip);
    cur.setStartAfter(space); cur.collapse(true);
    sel.removeAllRanges(); sel.addRange(cur);
    setMentionActive(false);
    setActiveMentionIndex(0);
    mentionRangeRef.current = null;
    syncContent();
  };

  // ── click ──
  const handleEditorClick = (e) => {
    const link = e.target.closest("a[data-link='true']");
    if (link) {
      e.preventDefault();
      saveRange();
      setLinkInit({ text: link.textContent, url: link.href });
      setLinkTarget(link);
      setPanel("link");
    }
  };

  // ── paste ──
  const handlePaste = (e) => {
    const items = Array.from(e.clipboardData?.items || []);
    const imgItem = items.find(it => it.type?.startsWith("image/"));
    if (imgItem) {
      e.preventDefault();
      const file = imgItem.getAsFile();
      const reader = new FileReader();
      reader.onload = (ev) => {
        restoreRange(); editorRef.current?.focus();
        document.execCommand("insertHTML", false, `<img src="${ev.target.result}" style="max-width:60%;border-radius:6px;margin:4px 0;" />`);
        setAttachments(p => [...p, { name: file.name || "pasted.png", size: file.size, file, base64: ev.target.result }]);
        syncContent();
      };
      reader.readAsDataURL(file);
      return;
    }
    const txt = e.clipboardData.getData("text/plain");
    if (/^https?:\/\/\S+$/i.test(txt.trim())) {
      e.preventDefault();
      document.execCommand("insertHTML", false,
        `<a href="${txt.trim()}" target="_blank" rel="noopener noreferrer" data-link="true">${txt.trim()}</a>\u00A0`);
      syncContent();
    }
  };

  // ── files ──
  const handleFiles = (e) => {
    Array.from(e.target.files || []).forEach(f => {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setAttachments(p => [...p, { name: f.name, size: f.size, file: f, base64: ev.target.result }]);
        if (f.type.startsWith("image/")) {
          restoreRange(); editorRef.current?.focus();
          document.execCommand("insertHTML", false, `<img src="${ev.target.result}" style="max-width:60%;border-radius:6px;margin:4px 0;" />`);
        }
        syncContent();
      };
      reader.readAsDataURL(f);
    });
    e.target.value = null;
  };

  // ── submit ──
  const handleSubmit = () => {
    const html = editorRef.current?.innerHTML || "";
    const text = editorRef.current?.innerText?.trim() || "";
    if (!text && !attachments.length) return;
    onSubmit?.({ html, text, attachments });
    if (editorRef.current) editorRef.current.innerHTML = "";
    setAttachments([]); setHasContent(false); setCharCount(0); setTableCtx(null);
  };

  const handleKeyDown = (e) => {
    if (mentionActive && filteredMentionUsers.length > 0) {
      if (e.key === "ArrowDown") { e.preventDefault(); setActiveMentionIndex(i => Math.min(i + 1, filteredMentionUsers.length - 1)); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); setActiveMentionIndex(i => Math.max(i - 1, 0)); return; }
      if (e.key === "Enter") { e.preventDefault(); const user = filteredMentionUsers[activeMentionIndex]; if (user) insertMention(user); return; }
      if (e.key === "Escape") { setMentionActive(false); mentionRangeRef.current = null; return; }
    }
    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") { e.preventDefault(); handleSubmit(); }
    if (e.key === "Escape") { setMentionActive(false); mentionRangeRef.current = null; setPanel(null); setTableCtx(null); }
    if (e.key === "Tab") { e.preventDefault(); exec("insertHTML", "\u00A0\u00A0\u00A0\u00A0"); }
  };

  // ✅ FIX: removed the old global mousedown panel-close handler entirely.
  //    Each panel (ColorPalette, EmojiPickerPanel, TablePicker) now manages its
  //    own outside-click logic via its own ref + capture-phase listener.
  //    The link panel is rendered at fixed position and doesn't need it.

  const TB = ({ cmd, value, icon, title, onClick }) => {
    const isActive = (() => { try { return document.queryCommandState(cmd); } catch { return false; } })();
    return (
      <button
        title={title}
        onMouseDown={e => { e.preventDefault(); onClick ? onClick(e) : exec(cmd, value); }}
        style={{ ...styles.tbBtn, background: isActive ? "#ede9fe" : "transparent", color: isActive ? "#7c3aed" : "#64748b" }}
      >
        <Icon d={ICONS[icon]} size={14} />
      </button>
    );
  };

  const insertCodeBlock = () => {
    restoreRange(); editorRef.current?.focus();
    document.execCommand("insertHTML", false,
      `<pre style="background:#1e293b;color:#e2e8f0;padding:12px 16px;border-radius:8px;font-family:monospace;font-size:13px;margin:6px 0;overflow-x:auto;white-space:pre;"><code>code here</code></pre><p><br></p>`);
    syncContent();
  };

  const insertBlockquote = () => {
    restoreRange(); editorRef.current?.focus();
    document.execCommand("insertHTML", false,
      `<blockquote style="border-left:3px solid #7c3aed;margin:6px 0;padding:4px 12px;color:#64748b;background:#faf5ff;border-radius:0 6px 6px 0;">Quote</blockquote><p><br></p>`);
    syncContent();
  };

  const editorMinH = compact ? 80 : 120;

  return (
    <div style={isFullscreen ? styles.fullscreenOverlay : { position: "relative" }}>
      <div
        ref={containerRef}
        style={{
          ...styles.container,
          ...(isFullscreen ? styles.fullscreen : {}),
          ...(focused ? styles.containerFocused : {}),
        }}
      >
        {isFullscreen && (
          <div style={styles.fsHeader}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>Comment editor</span>
            <button style={styles.iconBtn} onClick={() => setIsFullscreen(false)} />
          </div>
        )}

        {/* ── TOOLBAR ── */}
        <div style={styles.toolbar}>
          <div style={styles.tbGroup}>
            <TB cmd="bold" icon="bold" title="Bold (Ctrl+B)" />
            <TB cmd="italic" icon="italic" title="Italic (Ctrl+I)" />
            <TB cmd="underline" icon="underline" title="Underline" />
            <TB cmd="strikeThrough" icon="strikethrough" title="Strikethrough" />
            <TBSep />
            <button title="Inline code" onMouseDown={e => { e.preventDefault(); exec("formatBlock", "code"); }} style={styles.tbBtn}>
              <Icon d={ICONS.code} size={14} />
            </button>
            <button title="Code block" onMouseDown={e => { e.preventDefault(); insertCodeBlock(); }} style={styles.tbBtn}>
              <Icon d={ICONS.codeblock} size={14} />
            </button>
            <button title="Blockquote" onMouseDown={e => { e.preventDefault(); insertBlockquote(); }} style={styles.tbBtn}>
              <Icon d={ICONS.quote} size={14} />
            </button>
            <TBSep />
            <TB cmd="insertUnorderedList" icon="ul" title="Bullet list" />
            <TB cmd="insertOrderedList" icon="ol" title="Numbered list" />
            <TB cmd="indent" icon="indent" title="Indent" />
            <TB cmd="outdent" icon="outdent" title="Outdent" />
            <TBSep />

            {/* ── TEXT COLOR ── */}
            {/* ✅ FIX: panel rendered at fixed position (like LinkEditor) to avoid
                overflow clipping from any ancestor with overflow:hidden */}
            <div style={{ position: "relative" }}>
              <button
                title="Text color"
                style={styles.tbBtn}
                onMouseDown={e => { e.preventDefault(); togglePanel("foreColor", e); }}
              >
                <Icon d={ICONS.color} size={14} />
                <span style={{ display: "block", width: 12, height: 3, background: "#ef4444", borderRadius: 2, marginTop: 1 }} />
              </button>
              {panel === "foreColor" && (
                <div style={{ position: "fixed", top: panelPos.y, left: panelPos.x, zIndex: 9999 }}>
                  <ColorPalette cmd="foreColor" onClose={() => setPanel(null)} />
                </div>
              )}
            </div>

            {/* ── HIGHLIGHT ── */}
            <div style={{ position: "relative" }}>
              <button
                title="Highlight"
                style={styles.tbBtn}
                onMouseDown={e => { e.preventDefault(); togglePanel("hiliteColor", e); }}
              >
                <span style={{ fontSize: 13, lineHeight: 1 }}>A</span>
                <span style={{ display: "block", width: 12, height: 3, background: "#fef08a", borderRadius: 2, marginTop: 1 }} />
              </button>
              {panel === "hiliteColor" && (
                <div style={{ position: "fixed", top: panelPos.y, left: panelPos.x, zIndex: 9999 }}>
                  <ColorPalette cmd="hiliteColor" onClose={() => setPanel(null)} />
                </div>
              )}
            </div>

            <TBSep />

            {/* ── TABLE ── */}
            <div style={{ position: "relative" }}>
              <button
                title="Insert table"
                style={styles.tbBtn}
                onMouseDown={e => { e.preventDefault(); togglePanel("table", e); }}
              >
                <Icon d={ICONS.table} size={14} />
              </button>
              {panel === "table" && (
                <div style={{ position: "fixed", top: panelPos.y, left: panelPos.x, zIndex: 9999 }}>
                  <TablePicker onInsert={insertTable} onClose={() => setPanel(null)} />
                </div>
              )}
            </div>

            {/* ── LINK ── */}
            <div style={{ position: "relative" }}>
              <button
                title="Insert link"
                style={styles.tbBtn}
                onMouseDown={e => { e.preventDefault(); saveRange(); setLinkInit({}); setLinkTarget(null); togglePanel("link", e); }}
              >
                <Icon d={ICONS.link} size={14} />
              </button>
            </div>

            {/* ── ATTACH ── */}
            <button
              title="Attach file"
              style={styles.tbBtn}
              onMouseDown={e => { e.preventDefault(); saveRange(); fileRef.current?.click(); }}
            >
              <Icon d={ICONS.attach} size={14} />
            </button>

            {/* ── EMOJI ── */}
            <div style={{ position: "relative" }}>
              <button
                title="Emoji"
                style={styles.tbBtn}
                onMouseDown={e => { e.preventDefault(); togglePanel("emoji", e); }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>😊</span>
              </button>
              {/* ✅ FIX: rendered at fixed position so it's never clipped */}
              {panel === "emoji" && (
                <div style={{ position: "fixed", top: panelPos.y, left: panelPos.x, zIndex: 9999 }}>
                  <EmojiPickerPanel
                    onPick={insertEmoji}
                    onClose={() => setPanel(null)}
                  />
                </div>
              )}
            </div>

            {/* ── MENTION ── */}
            <button
              title="Mention (@)"
              style={styles.tbBtn}
              onMouseDown={e => {
                e.preventDefault();
                restoreRange(); editorRef.current?.focus();
                document.execCommand("insertText", false, "@");
                syncContent();
                setMentionQuery(""); setMentionActive(true); setMentionPos(getCaretCoords());
                setActiveMentionIndex(0);
                mentionRangeRef.current = window.getSelection()?.getRangeAt(0)?.cloneRange() ?? null;
              }}
            >
              <Icon d={ICONS.mention} size={14} />
            </button>
          </div>
          <div style={styles.tbGroup}>
            {/* <TBSep />
            <button title="Undo" style={styles.tbBtn} onMouseDown={e => { e.preventDefault(); exec("undo"); }}><Icon d={ICONS.undo} size={14} /></button>
            <button title="Redo" style={styles.tbBtn} onMouseDown={e => { e.preventDefault(); exec("redo"); }}><Icon d={ICONS.redo} size={14} /></button>
            <TBSep /> */}
            {/* <button title={previewMode ? "Edit" : "Preview"} style={{ ...styles.tbBtn, fontSize: 10, fontWeight: 700, padding: "0 7px", width: "auto" }}
              onMouseDown={e => { e.preventDefault(); setPreviewMode(p => !p); }}>
              {previewMode ? "Edit" : "Preview"}
            </button> */}
            {/* <button title={isFullscreen ? "Exit fullscreen" : "Fullscreen"} style={styles.tbBtn}
              onMouseDown={e => { e.preventDefault(); setIsFullscreen(p => !p); }}>
              <Icon d={isFullscreen ? ICONS.collapse : ICONS.expand} size={13} />
            </button> */}
          </div>
        </div>

        {/* ── EDITOR WRAPPER ── */}
        <div ref={editorWrapRef} style={{ position: "relative" }}>
          {tableCtx && !previewMode && (
            <TableToolbar
              cell={tableCtx.cell}
              table={tableCtx.table}
              containerRef={editorWrapRef}
              onAction={handleTableAction}
              onClose={() => setTableCtx(null)}
            />
          )}
          {tableCtx && !previewMode && (
            <TableResizeHandle
              table={tableCtx.table}
              containerRef={editorWrapRef}
            />
          )}

          {previewMode ? (
            <div
              style={{ ...styles.editor, minHeight: editorMinH, cursor: "default", background: "#f8fafc" }}
              dangerouslySetInnerHTML={{ __html: editorRef.current?.innerHTML || "<em style='color:#94a3b8'>Nothing to preview</em>" }}
            />
          ) : (
            <div
              ref={editorRef}
              contentEditable
              suppressContentEditableWarning
              data-placeholder={placeholder}
              style={{ ...styles.editor, minHeight: editorMinH, ...(isFullscreen ? { minHeight: "calc(100vh - 240px)" } : {}) }}
              onFocus={() => setFocused(true)}
              onBlur={() => { setFocused(false); saveRange(); }}
              onInput={handleInput}
              onKeyDown={handleKeyDown}
              onMouseUp={saveRange}
              onKeyUp={saveRange}
              onClick={handleEditorClick}
              onPaste={handlePaste}
            />
          )}
        </div>

        {/* ── ATTACHMENTS ── */}
        {attachments.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: "8px 12px", borderTop: "1px solid #eef0f4" }}>
            {attachments.map((a, i) => (
              <AttachChip key={i} name={a.name} size={a.size} onRemove={() => setAttachments(p => p.filter((_, j) => j !== i))} />
            ))}
          </div>
        )}

        {/* ── FOOTER ── */}
        <div style={styles.footer}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button
              style={{ ...styles.primaryBtn, opacity: hasContent ? 1 : 0.45, cursor: hasContent ? "pointer" : "not-allowed" }}
              disabled={!hasContent}
              onClick={handleSubmit}
            >
              {submitLabel}
            </button>
            {showCancelBtn && (
              <button
                style={styles.ghostBtn}
                onClick={() => {
                  if (editorRef.current) editorRef.current.innerHTML = "";
                  setAttachments([]); setHasContent(false); setTableCtx(null); onCancel?.();
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>

        <input ref={fileRef} type="file" multiple hidden onChange={handleFiles} />

        {/* ── LINK PANEL (always fixed) ── */}
        {panel === "link" && (
          <div style={{ position: "fixed", top: panelPos.y, left: panelPos.x, zIndex: 9999 }}>
            <LinkEditor initial={linkInit} onSave={handleLinkSave} onClose={() => setPanel(null)} />
          </div>
        )}

        {/* ── MENTION DROPDOWN ── */}
        {mentionActive && (
          <MentionDropdown
            users={mentionableUsers}
            query={mentionQuery}
            onSelect={insertMention}
            pos={mentionPos}
            activeIndex={activeMentionIndex}
          />
        )}
      </div>

      <style>{`
        [data-placeholder]:empty::before {
          content: attr(data-placeholder);
          color: #94a3b8;
          pointer-events: none;
          font-size: 13.5px;
        }
        [data-placeholder]:focus:empty::before { opacity: .6; }
        [contenteditable] a[data-link] { color: #3b82f6; cursor: pointer; text-decoration: underline; }
        [contenteditable] a[data-link]:hover { color: #1d4ed8; }
        [contenteditable] table { border-collapse: collapse; }
        [contenteditable] table tr:first-child td {
          background: #f1f5f9;
          font-weight: 600;
        }
        [contenteditable] td, [contenteditable] th { position: relative; }
        .col-rh {
          position: absolute;
          right: -3px; top: 0; bottom: 0; width: 6px;
          cursor: col-resize;
          z-index: 10;
          background: transparent;
          border-radius: 0 2px 2px 0;
          transition: background .15s;
        }
        .col-rh:hover { background: rgba(124,58,237,0.4); }
      `}</style>
    </div>
  );
}

/* ─── STYLES ─────────────────────────────────────────────────────── */
const styles = {
  container: {
    border: "1.5px solid #dde1e7", borderRadius: 8, background: "#fff",
    display: "flex", flexDirection: "column",
    overflow: "visible", transition: "border-color .15s, box-shadow .15s", position: "relative",
  },
  containerFocused: { borderColor: "#7c3aed", boxShadow: "0 0 0 3px rgba(124,58,237,.10)" },
  fullscreenOverlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 9990,
    display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
  },
  fullscreen: { width: "100%", maxWidth: 860, boxShadow: "0 24px 60px rgba(0,0,0,.3)" },
  fsHeader: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "10px 14px", borderBottom: "1px solid #eef0f4", background: "#fafbfc",
  },
  toolbar: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "6px 10px", borderBottom: "1px solid #eef0f4",
    background: "#fafbfc", borderRadius: "6px 6px 0 0", flexWrap: "wrap", gap: 4,
    /* ✅ FIX: overflow must be visible so fixed-position children aren't clipped */
    overflow: "visible",
  },
  tbGroup: { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" },
  tbBtn: {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    flexDirection: "column", gap: 1, width: 28, height: 28, borderRadius: 5,
    border: "none", background: "transparent", color: "#64748b",
    cursor: "pointer", padding: 0, transition: "background .1s, color .1s",
    fontFamily: "inherit", fontSize: 13, fontWeight: 600,
  },
  editor: {
    outline: "none", padding: "10px 14px", fontSize: 13.5, color: "#172b4d",
    lineHeight: 1.65, fontFamily: "system-ui, sans-serif",
    overflowY: "auto", wordBreak: "break-word", whiteSpace: "pre-wrap",
  },
  footer: {
    display: "flex", justifyContent: "flex-start", alignItems: "center",
    padding: "8px 12px", borderTop: "1px solid #eef0f4",
    background: "#fafbfc", borderRadius: "0 0 6px 6px",
  },
  kbd: {
    display: "inline-block", padding: "1px 5px", fontSize: 10, fontWeight: 600,
    border: "1px solid #cbd5e1", borderRadius: 4, background: "#f1f5f9",
    fontFamily: "monospace", color: "#64748b",
  },
  primaryBtn: {
    display: "inline-flex", alignItems: "center", gap: 6, height: 32,
    padding: "0 16px", borderRadius: 6, border: "none", background: "#0052CC",
    color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer",
    fontFamily: "inherit", transition: "opacity .15s",
  },
  ghostBtn: {
    height: 32, padding: "0 14px", borderRadius: 6, border: "1.5px solid #dde1e7",
    background: "transparent", color: "#64748b", fontSize: 13, fontWeight: 600,
    cursor: "pointer", fontFamily: "inherit",
  },
  iconBtn: {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    width: 28, height: 28, borderRadius: 5, border: "none",
    background: "transparent", color: "#64748b", cursor: "pointer", padding: 0,
  },
  floatingPanel: {
    background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10,
    boxShadow: "0 8px 24px rgba(0,0,0,.14)", padding: 10,
  },
  linkEditor: {
    width: 290, background: "#fff", border: "1px solid #e2e8f0",
    borderRadius: 10, boxShadow: "0 12px 32px rgba(0,0,0,.16)", overflow: "hidden",
  },
  linkEditorHeader: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "10px 14px", borderBottom: "1px solid #eef0f4", background: "#fafbfc",
  },
  miniInput: {
    height: 34, borderRadius: 6, border: "1.5px solid #dde1e7", padding: "0 10px",
    fontSize: 13, fontFamily: "inherit", color: "#172b4d", outline: "none",
    width: "100%", boxSizing: "border-box", background: "#fff",
  },


};